import { debounce } from 'lodash';

export default {
  data() {
    return {
      hoverProject: {
        target: null,
        project: null,
        hideHoverProjectPopupDebounce: debounce(() => {
          this.hoverProject.target = null;
        }, 200),
      },
    };
  },
  methods: {
    showHoverProjectPopup(target, project) {
      this.hoverProject.hideHoverProjectPopupDebounce.cancel();
      if (this.hoverProject.target !== target) {
        this.hoverProject.target = null;
        this.$nextTick(() => {
          this.hoverProject.target = target;
          this.hoverProject.project = project;
        });
      }
    },
    keepShowingHoverProjectPopup() {
      this.hoverProject.hideHoverProjectPopupDebounce.cancel();
    },
    hideHoverProjectPopup() {
      this.hoverProject.hideHoverProjectPopupDebounce();
    },
  },
};
